import $ from 'jquery';
import ScrollLock from '../utils/ScrollLock';
import AsyncView from './AsyncView';

let instance = null;

export default class CartMini {
  constructor() {
    if (instance) {
      return instance;
    }

    instance = this;

    this.el = document.querySelector('[data-cart-mini]');
    this.sidebar = this.el.querySelector('[data-cart-mini-sidebar]');
    this.sidebarClose = this.el.querySelector('[data-cart-mini-close]');
    this.content = this.el.querySelector('[data-cart-mini-content]');
    this.footer = this.el.querySelector('[data-cart-mini-footer]');

    this.refresh().done(() => {
      this.el.addEventListener('click', this.close.bind(this));
      this.sidebar.addEventListener('click', e => e.stopPropagation());
      this.sidebarClose.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.el.classList.add('cart-mini-open');
    ScrollLock.lock();
  }

  close() {
    this.el.classList.remove('cart-mini-open');
    ScrollLock.unlock();
  }

  removeItem(lineItem) {
    const $item = $(`[data-cart-mini-item="${lineItem}"]`, this.el);
    $item.addClass('cart-mini-item-loading');

    $.post(
      '/cart/change.js',
      {
        id: lineItem,
        quantity: 0,
      },
      () => this.refresh(),
      'json',
    );
  }

  refresh() {
    const $deferred = $.Deferred();
    this.el.classList.remove('cart-mini-loaded');

    $('[data-cart-mini-item-remove]', this.el).off('click.cart-mini');

    const $deferred1 = $.get(
      '/cart.js',
      data => $('[data-cart-mini-count]').text(data.item_count === 0 ? '' : data.item_count),
      'json',
    );

    const $deferred2 = AsyncView.load(
      '/cart',
      'mini',
    ).done((data) => {
      this.content.innerHTML = data.html.content;
      this.footer.innerHTML = data.html.footer;
      $('[data-cart-mini-item-remove]', this.el).on('click.cart-mini', (event) => {
        this.removeItem(event.currentTarget.getAttribute('data-cart-mini-item-remove'));
      });

      $(document).trigger('initialize-currency');

      this.el.classList.add('cart-mini-loaded');

      return $deferred.resolve();
    }).fail($deferred.reject());

    return $.when($deferred1, $deferred2);
  }
}
